import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import BlockchainApiManager from "../../../../app/services/blockchainApiManager";

const MultisigsTab = () => {
  const navigate = useNavigate();

  const {
    isLoading,
    error,
    data: msigProposals,
  } = useQuery(
    [`msigProposals`],
    () =>
      BlockchainApiManager.getTableByScope({
        code: "eosio.msig",
        table: "proposal",
        limit: -1,
        lower_bound: "",
      }),
    {}
  );

  if (error) {
    return (
      <>
        <p>Error fetching</p>
      </>
    );
  }

  if (isLoading) {
    return (
      <>
        <p>Loading...</p>
      </>
    );
  }

  const onMsigProposalClick = async (msigProposal) => {
    const approvals2Response = await BlockchainApiManager.getTableRows({
      code: "eosio.msig",
      scope: msigProposal.scope,
      table: "approvals2",
      limit: -1,
    });

    console.log(approvals2Response);
    if (approvals2Response && approvals2Response.rows) {
      if (msigProposal.count === 1) {
        navigate(
          `/msig/${msigProposal.scope}/${approvals2Response.rows[0].proposal_name}`
        );
      } else {
        msigProposal.proposals = approvals2Response.rows;
      }
    }
  };

  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th>Proposer</th>
            <th># of Proposals</th>
            <th>Proposal</th>
          </tr>
        </thead>
        <tbody>
          {msigProposals &&
            msigProposals.rows.map((msigProposal, index) => (
              <tr key={index}>
                <td>
                  <Link to={`/account/${msigProposal.scope}`}>
                    {msigProposal.scope}
                  </Link>
                </td>
                <td> {msigProposal.count} </td>
                <td>
                  {!msigProposal.proposals ? (
                    <button
                      className="btn btn-primary btn-sm"
                      type="button"
                      onClick={() => onMsigProposalClick(msigProposal)}
                    >
                      {msigProposal.count > 1
                        ? "Show Proposals"
                        : "Open Proposal"}
                    </button>
                  ) : null}

                  {msigProposal.proposals &&
                    msigProposal.proposals.map((proposal, index) => (
                      <Link
                        to={`/msig/${msigProposal.scope}/${proposal.proposal_name}`}
                        key={index}
                        className="d-block"
                      >
                        {proposal.proposal_name}
                      </Link>
                    ))}

                  {/* <Link to="/msig/.kgqy.waa/gxx1ub">gxx1ub</Link>
                  <br />
                  <Link to="/msig/.kgqy.waa/qiclij">qiclij</Link>
                  <br />
                  <Link to="/msig/.kgqy.waa/tmwgm1">tmwgm1</Link>
                  <br />
                  <Link to="/msig/.kgqy.waa/v3sryr">v3sryr</Link> */}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default MultisigsTab;
